import React from 'react';
import { Upload, Trash2 } from 'lucide-react';
import { Card, CardContent } from '../../ui/card';
import { Button } from '../../ui/button';
import { Input } from '../../ui/input';
import { Textarea } from '../../ui/textarea';
import FormLabel from './FormLabel';

interface BusinessDocumentsTabProps {
  businessDocuments: Array<{
    file_url: string;
    title: string;
    notes: string;
  }>;
  onAdd: () => void;
  onUpdate: (index: number, field: string, value: any) => void;
  onRemove: (index: number) => void;
  onFileUpload: (file: File, index: number) => Promise<void>;
}

export default function BusinessDocumentsTab({
  businessDocuments,
  onAdd,
  onUpdate,
  onRemove,
  onFileUpload,
}: BusinessDocumentsTabProps) {
  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-semibold">Dokumen Usaha / Kerja</h3>
        <p className="text-gray-500 text-sm">Upload dokumen pendukung usaha atau pekerjaan</p>
      </div>

      <div className="space-y-4">
        {businessDocuments.map((doc, index) => (
          <Card key={index}>
            <CardContent className="p-4 space-y-3">
              <div className="flex justify-between items-start">
                <h4 className="font-medium">Dokumen #{index + 1}</h4>
                <Button
                  type="button"
                  variant="ghost"
                  size="icon"
                  className="text-red-500 hover:text-red-700"
                  onClick={() => onRemove(index)}
                >
                  <Trash2 className="w-4 h-4" />
                </Button>
              </div>
              <div className="space-y-3">
                <div>
                  <FormLabel>File Dokumen</FormLabel>
                  <Input
                    type="file"
                    accept=".pdf,.jpg,.jpeg,.png"
                    onChange={e => {
                      const file = e.target.files?.[0];
                      if (file) {
                        onFileUpload(file, index);
                      }
                    }}
                  />
                  {doc.file_url && (
                    <p className="text-xs text-green-600 mt-1">✓ File sudah diupload</p>
                  )}
                </div>
                <div>
                  <FormLabel>Judul Dokumen</FormLabel>
                  <Input
                    placeholder="Judul Dokumen"
                    value={doc.title}
                    onChange={e => onUpdate(index, 'title', e.target.value)}
                  />
                </div>
                <div>
                  <FormLabel>Catatan</FormLabel>
                  <Textarea
                    placeholder="Catatan"
                    value={doc.notes}
                    onChange={e => onUpdate(index, 'notes', e.target.value)}
                    rows={2}
                  />
                </div>
              </div>
            </CardContent>
          </Card>
        ))}
        <Button type="button" onClick={onAdd} variant="outline" className="w-full">
          <Upload className="w-4 h-4 mr-2" /> Upload Dokumen
        </Button>
      </div>
    </div>
  );
}
